<template>
  <aside v-if="visible" class="consent" aria-label="Настройки аналитики">
    <p>Мы используем Яндекс Метрику, чтобы понимать, какие калькуляторы полезны, и улучшать сервис. Аналитика включится только с вашего согласия. <router-link to="/privacy">Подробнее</router-link></p>
    <div class="consent__actions">
      <button class="consent__button consent__button--primary" @click="choose(true)">Разрешить</button>
      <button class="consent__button" @click="choose(false)">Не разрешать</button>
    </div>
  </aside>
</template>

<script setup>
import { ref } from 'vue'
import { getAnalyticsConsent, isMetrikaConfigured, setAnalyticsConsent, trackGoal, trackPageView } from '@/helpers/metrika'
const visible = ref(isMetrikaConfigured() && getAnalyticsConsent() === null)
const choose = (accepted) => {
  setAnalyticsConsent(accepted)
  visible.value = false
  if (accepted) {
    trackPageView()
    trackGoal('analytics_consent', { status: 'accepted' })
  }
}
</script>

<style scoped>
.consent { position: fixed; z-index: 1000; left: 16px; right: 16px; bottom: 76px; max-width: 620px; margin: auto; padding: 16px; color: #fff; background: #24133f; border: 1px solid rgba(255,255,255,.25); border-radius: 16px; box-shadow: 0 12px 36px rgba(0,0,0,.35); font-size: 13px; line-height: 1.45; }
.consent p { margin: 0 0 12px; }
.consent a { color: #a9eeee; }
.consent__actions { display: flex; gap: 8px; }
.consent__button { flex: 1; padding: 10px 12px; border: 1px solid rgba(255,255,255,.35); border-radius: 10px; color: #fff; background: transparent; }
.consent__button--primary { border-color: #5db7b7; background: #5db7b7; color: #161026; font-weight: 600; }
</style>
